(function(algolia) {
  'use strict';

  algolia.translations = {
    search: "Nykyinen haku",
    noCollectionFound: "Kategorioita ei löytynyt",
    allProducts: "Katso kaikki tuotteet",
    matching: "haulla",
    sortBy: "Lajittele:",
    relevance: "Suosituimmat",
    outOf: "joukosta",
    resultsFound: "löytyneestä hakutuloksesta",
    oneResultFound: "1 hakutulos löytyi",
    noResultFound: "Hakutuloksia ei löytynyt",
    addToCart: "Lisää ostoskoriin",
    addToCartEbook:"Osta e-kirja",
    addToCartAudiobook:"Osta äänikirja",
    addToCartDigibook:"Osta digikirja",
    preOrder: "Tilaa ennakkoon ",
    searchForProduct: "Hae kategoriasta",
    selectedFilter: "Valitut suodattimet",
    clearAll: "Poista kaikki",
    noPageFound: "Sivua ei löytynyt",
    outOfStock: "Loppu",
    availableAtSelectedStore: "Saatavilla myymälässä",
    unavailableAtSelectedStore: "Ei saatavilla myymälässä",
    availableAtOtherStores: "Saatavilla __STORE_COUNT__ myymälässä",
    unavailableForPickup: "Ei saatavilla myymälöissä",
    unavailableForShipping: "Ei lähetettävissä",
    skAvailability: {
      sk2: "Lähetetään 1-3 arkipäivässä",
      sk3: "Lähetetään 2-4 arkipäivässä.",
      sk5: "Lähetetään 4-8 arkipäivässä.",
      sk10: "Tilaustuote, lähetetään 10-25 arkipäivässä.",
      sk20: "Tilaustuote, lähetetään 10-25 arkipäivässä.",
      sk40: "Tilaustuote, lähetetään 20-30 arkipäivässä.",
      sk60: "Tilaustuote, lähetetään 30-60 arkipäivässä.",
      sk100: "Arvioitu lähetys vko __PUBLICATION_WEEK__.",
      sk100_digital: "Saatavilla arviolta __PUBLICATION_WEEK__.",
      sk100_embargo: "Arvioitu ilmestyminen __PUBLICATION_DATE__.",
      sk100_unknown_date: "Painos loppu, uusintapainos tulossa.",
      sk150: "Painos loppu, tulossa vko __REPRINT_WEEK__.",
      sk150_digital: "I18n Error: Missing interpolation value &quot;publication_week&quot; for &quot;Tilapäisesti loppu, saatavilla arviolta {{ publication_week }}.&quot;",
      sk150_embargo: "Painos loppu, tulossa vko __REPRINT_DATE__.",
      sk150_unknown_date: "Painos loppu, uusintapainos tulossa.",
      sk200: "Ei lähetettävissä",
      sk470: "Lähtee kuljetukseen 1-2 arkipäivässä",
      sk490: "Ei lähetettävissä",
      sk500: "Ei lähetettävissä",
      sk600: "Ei lähetettävissä",
      sk650: "Ei lähetettävissä",
      sk700: "Ei lähetettävissä",
      skheti: "Saatavilla heti.",
      skpois: "Ei lähetettävissä"
    },
    unavailable: "Ei saatavilla",
    soldOut: "Loppuunmyyty",
    showVariantOptions: "Vaihtoehdot",
    goToProductPage: "Siirry tuotteen sivulle",
    searchTitle: "Hakutulokset",
    showFiltersButton: "Suodata hakutuloksia",
    filtersTitle: "Suodattimet",
    filtersInfo: "Suodata hakutuloksia klikkaamalla alta löytyviä suodattimia.",
    showResultsButton: "Suodata hakutuloksia",
    displayAsGrid: "Näytä tulokset ruudukkona.",
    displayAsList: "Näytä tulokset listana."
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Hakutuloksia ei löytynyt ' + render(text) + '';
    },

    in: function() {
      return 'ajassa ' + this.processingTimeMS / 1000  + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      var resultStr = 'Yritä {{0}} vähentää rajauksia {{1}} tai {{2}} käyttää eri hakusanaa {{3}}';
      for (var i = 0; i <= 3; i++) {
        var replace = '\{\{' + i + '\}\}';
        resultStr = resultStr.replace(replace,render(html_tags[i]));
      }
      return resultStr;
    },

    outOf: function() {
      return (
        'Hakutulokset ' +
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits)
      );
    },

    by: function(text, render) {
      return render(text) + '';
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
